import { KendoBaseComponent, KendoBaseDatasourceComponent, KendoSharedMethods } from '@progress/kendo-base-components-vue-wrapper'
import TreeViewProps from './TreeViewProps'

import Animation from './Animation'
import Checkboxes from './Checkboxes'
import Messages from './Messages'

export default {
    props: TreeViewProps,
    emits: {
        'kendowidgetready': null
    },
    mixins: [
        KendoBaseComponent,
        KendoBaseDatasourceComponent,
        KendoSharedMethods,
        Animation,
        Checkboxes,
        Messages
    ],
    mounted() {
        this._resolveChildren()

        kendo.jQuery(this.$el).kendoTreeView(this.widgetOptions)

        if(this.v3) {
            this.ready()
            this.$emit('kendowidgetready', this.kendoWidget())
        } else {
            this.$emit('kendowidgetready', this.kendoWidget())
        }
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoTreeView()
        },
        _resolveChildren() {
            const defaultSlot = (this.v3 && this.$slots.default && (typeof this.$slots.default === 'function')) ? this.$slots.default() : this.$slots.default
            const hasDataSource = this.v3 ? (!this.$props.dataSource) : (this.$options.propsData && !this.$options.propsData['dataSource'])
            if(hasDataSource && defaultSlot){
                var items = this.resolveInnerTags('kendo-treeview-item')

                if(items.length) {
                    this.widgetOptions['dataSource'] = items
                }
            }
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-treeview-vue-wrapper/src/KendoTreeView/KendoTreeViewMixin.js